import React from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';

import classes from '../../css/getCSS';


const layout = (props) => {
  let extraProps = {};
  if (props.background) {
    extraProps = {
      style: {
        backgroundImage: `url(${props.background})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        top: 0,
        position: 'fixed',
        width: '100%',
        height: '100%',
        overflow: 'auto',
      },
    };
  }

  let rootClasses = props.rootClass;

  if (!props.hideNavbar) {
    rootClasses = `${rootClasses} ${classes.mainLayout}`;
  }

  return (
    <React.Fragment>
      <CssBaseline />
      <div className={rootClasses} {...extraProps}>
        <div className={classes.container}>
          {props.children}
        </div>
      </div>
    </React.Fragment>
  );
};

export default layout;



// WEBPACK FOOTER //
// ./src/main/components/Layout.js